import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { uploadPublicFiles } from '../file/apiAdapters';
import { createPublicComplain, fetchPublicComplain } from './apiAdapters';
import { mapComplain } from './mapper';

// Giữ tên và chữ ký 2 hook cũ để 2 màn đang import (ComplainDetail, RequestInformationComplain) sửa ít nhất.
const complainKey = ({ orderCode, phoneNumber } = {}) => ['publicComplain', orderCode, phoneNumber];

export const useGetDetailComplain = ({ auth } = {}) => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: complainKey(auth),
    queryFn: ({ signal }) => fetchPublicComplain(auth, { signal }),
    select: mapComplain,
    enabled: !!auth?.orderCode && !!auth?.phoneNumber,
  });

  return { data, loading: isFetching, refetch };
};

// Upload rồi mới gửi khiếu nại, gộp trong 1 mutation để `loading` phủ cả 2 bước.
const uploadAndCreateComplain = async ({ auth, request }) => {
  const files = (request?.attachmentURLs || []).map((file) => file?.originFileObj).filter(Boolean);
  const attachmentUrls = await uploadPublicFiles(files);

  return createPublicComplain({
    orderCode: auth?.orderCode,
    phoneNumber: auth?.phoneNumber,
    productIds: request?.productIds,
    reason: request?.reason,
    demand: request?.demand,
    description: request?.description,
    total: request?.total,
    paymentMethod: request?.paymentMethod,
    attachmentUrls,
  });
};

export const useCreateOrderComplain = () => {
  const queryClient = useQueryClient();

  // Mutation mặc định không retry — đúng ý, vì gửi lại có thể tạo khiếu nại trùng.
  const { mutateAsync, isLoading, error } = useMutation({
    mutationFn: uploadAndCreateComplain,
    // Màn xem khiếu nại có thể đã cache kết quả "chưa có khiếu nại" từ trước; bắt nó tải lại.
    onSuccess: (_, { auth }) => queryClient.invalidateQueries({ queryKey: complainKey(auth) }),
  });

  return { handleCreateOrderComplain: mutateAsync, loading: isLoading, error };
};
